var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-it-up"},[(!_vm.isMdXSmall)?_c('landing-content-desktop'):_c('landing-content-mobile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }